import styled, { css } from "styled-components";

import { PUBLISH_STATUSES } from "constants/models";
import { COLORS } from "constants/colorScheme";

export const Container = styled.div`
  padding: 4px 16px;

  border-radius: 4px;

  ${({ status }: { status: string }) => {
    switch (status) {
      case PUBLISH_STATUSES.DRAFT:
        return css`
          background-color: ${COLORS.GREY_40};

          && .MuiTypography-root {
            color: ${COLORS.BLACK};
          }
        `;
      case PUBLISH_STATUSES.PREVIEW:
        return css`
          background-color: ${COLORS.LAVENDER_20};

          && .MuiTypography-root {
            color: ${COLORS.LAVENDER};
          }
        `;
      case PUBLISH_STATUSES.SCHEDULE_FOR_REMOVE:
        return css`
          background-color: ${COLORS.PURPLE_20};

          && .MuiTypography-root {
            color: ${COLORS.PURPLE};
          }
        `;
      case PUBLISH_STATUSES.PUBLISHED:
        return css`
          background-color: ${COLORS.CYAN_20};

          && .MuiTypography-root {
            color: ${COLORS.CYAN};
          }
        `;
    }
  }}
`;
